module.exports = __webpack_public_path__ + "img/bucvar-1771-pagina-de-titlu-big.b67d7c89.jpg";